import * as React from 'react';
import {Checkbox, Stack, FormControlLabel} from '@mui/material';
import { Male, Female } from '@mui/icons-material';

export default function GenderCheckbox(props) {

  function MaleCheckBox() {
    return (
      <Checkbox 
        icon={<Male style={{ color: 'lightgrey' }} />} 
        checkedIcon={<Male />} 
        onChange={onMaleChange} 
        checked={props.gender === 'm'} 
      />
    )
  }

  function FemaleCheckBox() {
    return (
      <Checkbox 
        icon={<Female style={{ color: 'lightgrey' }} />} 
        checkedIcon={<Female />} 
        onChange={onFemaleChange} 
        checked={props.gender === 'f'} 
      />
    )
  }

  function onMaleChange(event) {
    if (event.target.checked) {
      // Wenn männlich ausgewählt wird
      props.setGender('m');
    } else {
      // Wenn männlich entfernt wird
      props.setGender(null);
    }
  }

  function onFemaleChange(event) {
    if (event.target.checked) {
      // Wenn weiblich ausgewählt wird
      props.setGender('f');
    } else {
      // Wenn weiblich entfernt wird
      props.setGender(null);
    }
  }

  return (
    <Stack direction='row' justifyContent='center'>
      <FormControlLabel control={<FemaleCheckBox />} label="weiblich" labelPlacement="bottom" />
      <FormControlLabel control={<MaleCheckBox />} label="männlich" labelPlacement="bottom" />
    </Stack>
  );
}


